// extracted by mini-css-extract-plugin
module.exports = {"root":"Panel_root__1PcZ3","innerwrapper":"Panel_innerwrapper__jl9aG"};